import { useSessionKey } from "@auth/sessionStore";
import {
  type InboundRingMode,
  type OutboundLine,
  phoneSetupClient,
} from "@phone/phoneSetupClient";
import { phoneSetupKeys } from "@phone/phoneSetupQueries";
import { useQuery } from "@tanstack/react-query";

type OutboundLines =
  | { status: "loading" }
  | { status: "unavailable"; message: string }
  | {
      status: "ready";
      /** Enabled lines only. */
      lines: OutboundLine[];
      inboundRing: InboundRingMode;
      outboundComputerDefault: boolean;
      outboundDisclosureSpoken: boolean;
    };

/** The outbound switch isn't on this route; brian refuses a call placed while off as `outbound_disabled`. */
export const useOutboundLines = (): OutboundLines => {
  const sessionKey = useSessionKey();
  const lines = useQuery({
    queryKey: phoneSetupKeys.outboundLines(sessionKey),
    queryFn: phoneSetupClient.getOutboundLines,
    enabled: sessionKey !== "",
  });
  if (lines.data) return { status: "ready", ...lines.data };
  if (lines.isError)
    return {
      status: "unavailable",
      message: "Brian couldn't read which lines to ring.",
    };
  return { status: "loading" };
};
